'use client';

import animationData from '@/animations/insights.json';
import { FC } from 'react';
import LottieHandler from './LottieHandler';

export interface AnimationInsightsProps {
  playing?: boolean;
}

const AnimationInsights: FC<AnimationInsightsProps> = ({ playing }) => {
  return (
    <div className="flex">
      <LottieHandler animationData={animationData} playing={playing} />
    </div>
  );
};

export default AnimationInsights;
